import { defaultObj } from './state'

export default {
  getAllStates (state, stateData) {
    if (stateData.states) {
      state.all = stateData.states
    }
  },

  reset (state) {
    state = Object.assign(state, defaultObj)
  }
}
